import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { bindFormModule } from '../../shared/formBinding.js';
import { formModalSaved, isFormModalOpen } from '../../shared/formModal.js';
import { hideLoading, notifyError, notifySuccess, showLoading } from '../../shared/notify.js';

async function submit(form) {
  const submitButton = form.querySelector('button[type="submit"]');
  const { stammdatenId, typ } = form.dataset;
  const data = Object.fromEntries(new FormData(form).entries());

  data.aktiv = form.querySelector('#aktiv')?.checked ?? true;

  // The empty option means "no category". Sending '' would fail the isIn
  // check, so the key comes off entirely and the schema default applies.
  if (!data.kategorie) delete data.kategorie;

  // The type is fixed by the page, and a PATCH may not change it anyway.
  if (!stammdatenId) data.typ = typ;

  if (submitButton) submitButton.disabled = true;
  showLoading('Wird gespeichert …');

  try {
    if (stammdatenId) await http.patch(`/stammdaten/${stammdatenId}`, data);
    else await http.post('/stammdaten', data);

    // In the dialog the list is already behind it, so closing and refetching
    // shows the result without a reload. On the standalone page there is
    // nothing to go back to, so it navigates and the flash key carries the
    // message across the load.
    if (isFormModalOpen()) {
      hideLoading();
      formModalSaved();
      notifySuccess(stammdatenId ? 'Eintrag wurde aktualisiert.' : 'Eintrag wurde erstellt.');
    } else {
      window.location.href = withFlash(
        `/stammdaten/${typ}`,
        stammdatenId ? 'stammdaten-aktualisiert' : 'stammdaten-erstellt'
      );
    }
  } catch (err) {
    hideLoading();
    if (submitButton) submitButton.disabled = false;
    notifyError(
      err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
    );
  }
}

export function initStammdatenForm() {
  // No setup callback: the Fachgebiet form used to couple an Ebene picker to a
  // parent select, and that was the only field on any of these six forms that
  // needed wiring beyond the submit.
  bindFormModule('stammdaten-form', submit);
}
